// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3WmVc","dragIcon":"Choice_dragIcon__1Q5dJ","left":"Choice_left__UjeVL","input":"Choice_input__3zewB"};